type Product = {
  id: string
  productType: Maybe<ProductType>
}

export const useProductStore = defineStore(
  'ltc_product_id',
  () => {
    const licensedTerritory = useLicensedTerritory()

    const productIdMap = ref<Record<string, Product>>({})

    const deleteProductId = (productName: string) => {
      /* eslint-disable @typescript-eslint/no-dynamic-delete */
      delete productIdMap.value[
        `${productName.toLocaleLowerCase()}_${licensedTerritory}`
      ]
    }

    const setProduct = (
      id: string,
      productName: string,
      productType: ProductType,
    ) => {
      productIdMap.value[
        `${productName.toLocaleLowerCase()}_${licensedTerritory}`
      ] = { id: id.toLocaleLowerCase(), productType }
    }

    const getProduct = (productName: string): Maybe<Product> => {
      const id =
        productIdMap.value[
          `${productName.toLocaleLowerCase()}_${licensedTerritory}`
        ] || null

      // Fallback for old storage schema
      if (typeof id === 'string') {
        return {
          id,
          productType: null,
        }
      }

      return id
    }

    return {
      deleteProductId,
      getProduct,
      productIdMap,
      setProduct,
    }
  },
  {
    persist: {
      storage: piniaPluginPersistedstate.localStorage(),
    },
  },
)
